module.exports = {"370213001":"振华路街道","370213003":"沧口街道","370213004":"兴华路街道","370213005":"兴城路街道","370213006":"李村街道","370213007":"虎山路街道","370213008":"浮山路街道","370213010":"湘潭路街道","370213011":"楼山街道","370213012":"九水街道","370213013":"世园街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370213.json
// module id = 1368
// module chunks = 0